import { createStore } from 'vuex'
import { ios } from '@/core/utils/ua'

type UserInfo = {
  nick: string
  face_url: string
  openid?: string
}

type Unlock = {
  id: number
  icon: string
  name: string
}

type ShareFw = {
  id: string
  content: string
}

type State = {
  isLoging: boolean
  isLogin: boolean
  coin: number
  redpack: number
  userInfo: UserInfo
  inviteType: number
  inviteCode: string
  unlock: Unlock
  shareFid: string
  shareFw: ShareFw
  sys: number
}

const state: State = {
  isLoging: false,
  isLogin: false,
  coin: 0,
  redpack: 0,
  userInfo: {
    nick: '新闻用户',
    // eslint-disable-next-line @typescript-eslint/camelcase
    face_url: 'https://sola.gtimg.cn/aoi/sola/20201218145820_FLbr2xO6Vd.png'
  },
  inviteType: 0,
  inviteCode: '',
  unlock: {
    id: 0,
    icon: '',
    name: ''
  },
  shareFid: '',
  shareFw: {
    id: '',
    content: ''
  },
  sys: ios ? 2.8 : 2.2
}

const mutations = {
  setIsLoging(state: State, loging: boolean) {
    state.isLoging = loging
  },

  setIsLogin(state: State, login: boolean) {
    state.isLogin = login
  },

  setCoin(state: State, coin: number) {
    state.coin = coin
  },

  setRedpack(state: State, redpack: number) {
    state.redpack = redpack
  },

  setUserInfo(state: State, userInfo: UserInfo) {
    state.userInfo = userInfo
  },

  setInviteType(state: State, inviteType: number) {
    state.inviteType = inviteType
  },

  setInviteCode(state: State, inviteCode: string) {
    state.inviteCode = inviteCode
  },

  setUnlock(state: State, unlock: Unlock) {
    state.unlock = unlock
  },

  setShareFid(state: State, fid: string) {
    state.shareFid = fid
  },

  setShareFw(state: State, fw: ShareFw) {
    state.shareFw = fw
  },

  setSys(state: State, sys: number) {
    state.sys = sys
  }
}

export default createStore({
  state,
  mutations
})
